import Canonical from './Canonical';

export default Canonical;
